export function pushPreSentryMetric(name, elapsed, unit = 'millisecond') {
  window.SENTRY_M = window.SENTRY_M || []
  window.SENTRY_M.push({ name, elapsed, unit })
}

export function preSentryMetric(name, unit = 'millisecond') {
  const start = performance.now()

  return {
    finish() {
      const elapsed = Math.round(performance.now() - start)
      pushPreSentryMetric(name, elapsed, unit)
    },
  }
}
